var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c("div", { staticClass: "dialog_wrap" }, [
        _c("div", { staticClass: "dialog_content" }, [
          _c("div", { staticClass: "dialog_message" }, [
            _vm._v("\n      " + _vm._s(_vm.cont.message) + "\n    ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dialog_btnBox" }, [
            _c(
              "button",
              {
                staticClass: "btn btn_ok",
                on: {
                  click: function($event) {
                    return _vm.btnOk()
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(_vm.cont.btn.ok) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn_cancel",
                on: {
                  click: function($event) {
                    return _vm.btnCancel()
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(_vm.cont.btn.no) + "\n      ")]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-752a2e50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-752a2e50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/noticeDialog.vue
// module id = null
// module chunks = 